/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export enum ServicesFrontendEnum {
    GENERAL,
    FLOATINGIP,
    HEADER,
    SSL,
    CLIENTCONNECTIONS,
}
